import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["user.userProfileSuccess"],
  action => action
);
